import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'rangeToArray'
})
export class RangeToArrayPipe implements PipeTransform {

  transform(start: number, end: number) {
    if (start && end) {
      const array: number[] = new Array();
      for (let i = start; i <= end; i++) {
        array.push(i);
      }

      return array;
    }
  }

}
